import { useCallback } from "react";
import { useMutation } from "react-query";

import type { UserSubscriptionMutationResponse } from "@jti/rest-api-types";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { SubscriptionsApi } from "../../../services/subscriptions/SubscriptionsApi";

type ResumeSubscriptionError = {
  message: string;
  error_code: string;
};

type UseResumeUserSubscriptionArgs = {
  onSuccess: (data: UserSubscriptionMutationResponse) => void;
};

export const useResumeUserSubscription = ({ onSuccess }: UseResumeUserSubscriptionArgs) => {
  const subscriptionsApi = SubscriptionsApi.init();

  const { mutateAsync, isLoading, isSuccess, isError, error } = useMutation<
    UserSubscriptionMutationResponse,
    ResumeSubscriptionError,
    string
  >(
    MUTATION_KEYS.resumeUserSubscription,
    (subscriptionId: string) => subscriptionsApi.resumeUserSubscription(subscriptionId),
    {
      onSuccess,
    }
  );

  const resumeSubscription = useCallback((subscriptionId: string) => mutateAsync(subscriptionId), [mutateAsync]);

  return {
    resumeSubscription,
    isLoading,
    isSuccess,
    isError,
    error,
  };
};
